// extracted by mini-css-extract-plugin
export default {"container":"Cb15BuXHGcjGRxnOpeR4","messageWrapper":"WO2bIA0XOT8JFOgG2Ch6"};